import { gql } from '@apollo/client';

export const BLOCKED_TEMPLATE_CONTENT_BUILD_EMAIL_PREVIEW_FRAGMENT = gql`
    fragment BlockedTemplateContentBuildEmailPreviewFragment on TemplateContentBuildEmailPreview {
        id
        createdAt
        emailUpload {
            signedUrl
        }
        location {
            id
            title
            client {
                id
                title
            }
        }
        recipientEmail
        sentByUsername
        subject
    }
`;
